export const ObserverStore = () => {
  const subscribers = new Set();

  let el;

  let { width = 0, height = 0 } = el?.getBoundingClientRect() || {};

  const notify = () => {
    subscribers.forEach((subscriber) => {
      subscriber({ width, height });
    });
  };

  let rafId = null;
  const observer = new ResizeObserver((entries) => {
    const { borderBoxSize } = entries.at(-1);
    width = borderBoxSize[0].inlineSize;
    height = borderBoxSize[0].blockSize;

    // Avoid `ResizeObserver loop completed with undelivered
    // notifications` error by deferring & debouncing store update
    // until next animation frame.
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(() => {
      rafId = null;
      notify();
    });
  });

  const start = () => {
    if (el) {
      const rect = el.getBoundingClientRect();
      width = rect.width;
      height = rect.height;
      observer.observe(el);
    }
  };
  const stop = () => {
    if (el) {
      observer.unobserve(el);
      width = 0;
      height = 0;
    }
  };

  const set = (element) => {
    if (el !== element && subscribers.size > 0) {
      stop();
    }
    el = element;
    if (subscribers.size > 0) {
      start();
    }
    notify();
  };

  const subscribe = (subscriber) => {
    subscribers.add(subscriber);

    if (subscribers.size === 1) {
      start();
    }
    subscriber({ width, height });

    return () => {
      subscribers.delete(subscriber);
      if (subscribers.size === 0) {
        stop();
      }
    };
  };

  return { subscribe, set };
};
